/**
 * @generated SignedSource<<098363a2417150f92e67f44e0f254719>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RecruitYourPanel_recruit$data = {
  readonly id: string;
  readonly status: ScreenersRecruitStatusChoices;
  readonly " $fragmentType": "RecruitYourPanel_recruit";
};
export type RecruitYourPanel_recruit$key = {
  readonly " $data"?: RecruitYourPanel_recruit$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecruitYourPanel_recruit">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitYourPanel_recruit",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "RecruitNode",
  "abstractKey": null
};

(node as any).hash = "9feee4504226c9aa9089cb5ea2bae2f9";

export default node;
